<template>
    <!-- top header - login -->
    <div class="more-content">
        <div class="more-container" v-if="isLogin">
            <router-link :to="{ name: 'myProfile' }">
                <div class="join-container">
                    <Avatar class="join-avatar-img" />
                    <div class="join-team-data">
                        <div class="join-team-title name">
                            {{ userInfo.displayName }}
                            <SvgIcon
                                icon="more.editnickname"
                                className="edit-pen"
                            ></SvgIcon>
                        </div>
                        <div class="join-team-content member-since">
                            {{ $t("MEMBER_SINCE") }} {{ mySinceDate }}
                        </div>
                    </div>
                </div>
            </router-link>

            <div class="invite-card" @click="handleShare()">
                <div class="invite-data">
                    <div class="invite-title">
                        {{ $t("INVITE_YOUR_FRIEND") }}
                    </div>
                    <div class="invite-content">{{ $t("INVITE_CONTENT") }}</div>
                </div>

                <div class="invite-button btn-aspn-only-default">
                    <div class="flex-shrink">{{ $t("SHARE") }}</div>
                    <SvgIcon
                        className="share-icon"
                        icon="popup.profile.share"
                    ></SvgIcon>
                </div>
            </div>
        </div>

        <!-- top header not login -->
        <div class="more-container" v-else>
            <div class="join-container">
                <IconMode>
                    <template #default="{ index }">
                        <img
                            src="@static/images/icons/aspn_icon/icon_avatar.png"
                            v-if="['lightWeb', 'lightWebapp'].includes(index)"
                            class="join-avatar-img"
                        />
                        <img
                            src="@static/images/icons/aspn_icon/icon_avatar_dark.png"
                            v-else-if="
                                ['darkWeb', 'darkWebapp'].includes(index)
                            "
                            class="join-avatar-img"
                        />
                    </template>
                </IconMode>
                <div class="join-team-data">
                    <div class="join-team-title">
                        {{ $t("JOIN_YOUR_TEAM_NOW") }}
                    </div>
                    <div class="join-team-content">
                        {{ $t("JOIN_TEAM_CONTENT") }}
                    </div>
                </div>
            </div>
            <div class="tab">
                <div
                    class="tab-item"
                    v-for="(item, index) in tabs"
                    :key="index"
                    @click="handleClickTabs(item.pathName)"
                >
                    {{ $t(item.name) }}
                </div>
            </div>
        </div>

        <!-- setting list -->
        <div class="list-container">
            <div class="list-title list-title-settings">
                {{ $t("SETTINGS") }}
            </div>

            <div class="list">
                <template v-for="(item, index) in settingList">
                    <div
                        class="list-item"
                        @click="handleListItem(item)"
                        v-if="
                            item.isLogin === undefined ||
                            (item.isLogin === true && isLogin)
                        "
                    >
                        <div>
                            <div v-if="item.name === 'COUNTRY_AND_LANGUAGE'">
                                {{ isLogin ? $t(item.name) : $t("LANGUAGE") }}
                            </div>
                            <div v-else>
                                {{ $t(item.name) }}
                            </div>
                            <!-- language display -->
                            <div
                                v-if="item.name === 'COUNTRY_AND_LANGUAGE'"
                                class="language-text"
                            >
                                <div class="country-icon-box" v-if="isLogin">
                                    <img
                                        :src="
                                            require(`../../../static/images/flags/${myCountryIcon}.png`)
                                        "
                                        class="country-icon"
                                    />
                                </div>
                                {{ isLogin ? currentCountryObj.country : "" }} -
                                {{ currentLanguageObj.displayName }}
                            </div>
                        </div>
                        <!-- theme switch -->
                        <div v-if="item.name === 'THEME'">
                            <label
                                class="switch"
                                :class="isLight ? 'is-light' : 'is-dark'"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    class="switch-sun"
                                    v-if="isLight"
                                >
                                    <path
                                        d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z"
                                        fill="#E6C200"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V3C12.75 3.41421 12.4142 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3V2C11.25 1.58579 11.5858 1.25 12 1.25ZM4.39861 4.39861C4.6915 4.10572 5.16638 4.10572 5.45927 4.39861L5.85211 4.79145C6.145 5.08434 6.145 5.55921 5.85211 5.85211C5.55921 6.145 5.08434 6.145 4.79145 5.85211L4.39861 5.45927C4.10572 5.16638 4.10572 4.6915 4.39861 4.39861ZM19.6011 4.39887C19.894 4.69176 19.894 5.16664 19.6011 5.45953L19.2083 5.85237C18.9154 6.14526 18.4405 6.14526 18.1476 5.85237C17.8547 5.55947 17.8547 5.0846 18.1476 4.79171L18.5405 4.39887C18.8334 4.10598 19.3082 4.10598 19.6011 4.39887ZM1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H3C3.41421 11.25 3.75 11.5858 3.75 12C3.75 12.4142 3.41421 12.75 3 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12ZM20.25 12C20.25 11.5858 20.5858 11.25 21 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H21C20.5858 12.75 20.25 12.4142 20.25 12ZM18.1476 18.1476C18.4405 17.8547 18.9154 17.8547 19.2083 18.1476L19.6011 18.5405C19.894 18.8334 19.894 19.3082 19.6011 19.6011C19.3082 19.894 18.8334 19.894 18.5405 19.6011L18.1476 19.2083C17.8547 18.9154 17.8547 18.4405 18.1476 18.1476ZM5.85211 18.1479C6.145 18.4408 6.145 18.9157 5.85211 19.2086L5.45927 19.6014C5.16638 19.8943 4.6915 19.8943 4.39861 19.6014C4.10572 19.3085 4.10572 18.8336 4.39861 18.5407L4.79145 18.1479C5.08434 17.855 5.55921 17.855 5.85211 18.1479ZM12 20.25C12.4142 20.25 12.75 20.5858 12.75 21V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V21C11.25 20.5858 11.5858 20.25 12 20.25Z"
                                        fill="#E6C200"
                                    />
                                </svg>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    class="switch-moon"
                                    v-else
                                >
                                    <path
                                        d="M19.8999 2.30719C19.739 1.8976 19.1614 1.8976 19.0005 2.30719L18.5701 3.40247C18.521 3.52752 18.4224 3.62651 18.2978 3.67583L17.2065 4.1078C16.7984 4.26934 16.7984 4.849 17.2065 5.01054L18.2978 5.44252C18.4224 5.49184 18.521 5.59082 18.5701 5.71587L19.0005 6.81115C19.1614 7.22074 19.739 7.22074 19.8999 6.81116L20.3303 5.71587C20.3794 5.59082 20.478 5.49184 20.6026 5.44252L21.6939 5.01054C22.102 4.849 22.102 4.26934 21.6939 4.1078L20.6026 3.67583C20.478 3.62651 20.3794 3.52752 20.3303 3.40247L19.8999 2.30719Z"
                                        fill="#E6C200"
                                    />
                                    <path
                                        d="M16.0327 8.12966C15.8717 7.72008 15.2942 7.72008 15.1332 8.12966L14.9763 8.52901C14.9272 8.65406 14.8286 8.75304 14.704 8.80236L14.3061 8.95986C13.898 9.1214 13.898 9.70106 14.3061 9.8626L14.704 10.0201C14.8286 10.0694 14.9272 10.1684 14.9763 10.2935L15.1332 10.6928C15.2942 11.1024 15.8717 11.1024 16.0327 10.6928L16.1896 10.2935C16.2387 10.1684 16.3373 10.0694 16.4619 10.0201L16.8598 9.8626C17.2679 9.70106 17.2679 9.1214 16.8598 8.95986L16.4619 8.80236C16.3373 8.75304 16.2387 8.65406 16.1896 8.52901L16.0327 8.12966Z"
                                        fill="#E6C200"
                                    />
                                    <path
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 11.5373 21.3065 11.4608 21.0672 11.8568C19.9289 13.7406 17.8615 15 15.5 15C11.9101 15 9 12.0899 9 8.5C9 6.13845 10.2594 4.07105 12.1432 2.93276C12.5392 2.69347 12.4627 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        fill="#26B3FF"
                                    />
                                </svg>
                                <input
                                    type="checkbox"
                                    v-model="isLight"
                                    @change="changeMode"
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>

                        <SvgIcon
                            icon="more.arrow.right"
                            v-if="item.arrow"
                        ></SvgIcon>
                    </div>
                </template>
            </div>
        </div>

        <!-- info list -->
        <div class="list-container">
            <div class="list-title">
                {{ $t("INFO") }}
            </div>

            <div class="list">
                <div
                    class="list-item"
                    v-for="(item, index) in infoList"
                    @click="handleListItem(item)"
                >
                    {{ $t(item.name) }}
                    <SvgIcon
                        icon="more.arrow.right"
                        v-if="item.arrow"
                    ></SvgIcon>
                </div>
            </div>
        </div>

        <div class="sign-out" v-if="isLogin">
            <span class="sign-out-text" @click="handleLogout()">
                {{ $t("SIGN_OUT") }}
            </span>
        </div>

        <div class="more-footer-container">
            <div class="version-text">
                {{ $t("VERSION") }} {{ $t("ASIASPORTS") }}
                {{ new Date().getFullYear() }}.01
            </div>

            <div class="mb-1rem" v-if="displayHeaderDownloadIcon">
                <DownloadIconList />
            </div>

            <div class="copyright">
                <div>
                    {{
                        $t("COPYRIGHT_ASPN", { year: new Date().getFullYear() })
                    }}
                </div>
                <div>{{ $t("ALL_RIGHT_RESERVED") }}</div>
            </div>
        </div>

        <Popup
            v-model:show="isShowLanguageList"
            type="bottom"
            :className="[`popup-country`, !isLogin ? 'unlogin' : '']"
        >
            <template #header>
                <div class="country-header">
                    <div class="">{{ $t("SELECT_COUNTRY_AND_LANGUAGE") }}</div>
                    <div class="done-text" @click="handleDone()">
                        {{ $t("DONE") }}
                    </div>
                </div>
            </template>
            <div
                style="overflow-y: scroll; height: calc(100vh - 10vh - 62.75px)"
                v-if="isLogin"
            >
                <!-- {{ isShowLanguageList }} -->
                <div style="height: 100%">
                    <div class="language-title">
                        {{ $t("SUGGESTED") }}
                    </div>
                    <template v-for="(item, index) in countryList" :key="index">
                        <div
                            v-if="item.countryCode === suggesstionCountryCode"
                            class="country-lang-item"
                        >
                            <div class="country-item">
                                <img
                                    class="img-contain flag-icon mr-05rem"
                                    :src="
                                        require(`../../../static/images/flags/${item.icon}.png`)
                                    "
                                />
                                {{ item.name }}
                            </div>

                            <div class="language-list">
                                <div
                                    class="language-item"
                                    v-for="(sec, index2) in item.countryLang"
                                    :key="index"
                                    :class="[
                                        {
                                            selected: sec.selected2,
                                        },
                                    ]"
                                    @click="selectLang(countryList, item, sec)"
                                >
                                    {{ sec.displayName }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="language-title others">
                        {{ $t("OTHERS") }}
                    </div>
                    <template v-for="(item, index) in countryList" :key="index">
                        <div
                            class="country-lang-item"
                            v-if="item.countryCode !== suggesstionCountryCode"
                        >
                            <div class="country-item">
                                <img
                                    class="img-contain flag-icon mr-05rem"
                                    :src="
                                        require(`../../../static/images/flags/${item.icon}.png`)
                                    "
                                />
                                {{ item.name }}
                            </div>

                            <div class="language-list">
                                <div
                                    class="language-item"
                                    v-for="(sec, index2) in item.countryLang"
                                    :key="index"
                                    :class="[
                                        {
                                            selected: sec.selected2,
                                        },
                                    ]"
                                    @click="selectLang(countryList, item, sec)"
                                >
                                    {{ sec.displayName }}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div v-else>
                <div
                    v-for="(item, index) in countryListNotLogin"
                    class="country-lang-item"
                >
                    <div class="language-list">
                        <div
                            class="language-item"
                            v-for="(sec, index2) in item.countryLang"
                            :key="index"
                            :class="[
                                {
                                    selected: sec.selected2,
                                },
                            ]"
                            @click="selectLang(countryListNotLogin, item, sec)"
                        >
                            {{ sec.displayName }}
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    </div>
    <ToastrDesktop ref="toastrDesktop" :text="'LINK_COPIED'"></ToastrDesktop>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Avatar from "@/components/account/Avatar.vue";
import config from "@/js/config.js";
import DownloadIconList from "@/components/socialMediaSharing/DownloadIconList.vue";
import ToastrDesktop from "@/components/toastr/ToastrDesktop.vue";
export default {
    name: "WebappMore",
    data() {
        return {
            displayHeaderDownloadIcon: config.headerDownloadIcon,
            isShowLanguageList: false,
            isLight: false,
            tabs: [
                {
                    name: "SIGN_IN",
                    pathName: "signin",
                },
                {
                    name: "JOIN_NOW",
                    pathName: "signup",
                },
            ],
            settingList: [
                {
                    name: "THEME",
                    type: "switch",
                },
                {
                    name: "COUNTRY_AND_LANGUAGE",
                    type: "language",
                    arrow: true,
                },
                {
                    name: "ACCOUNT",
                    arrow: true,
                    isLogin: true,
                    pathName: "changePasswordSelection",
                },
            ],
            infoList: [
                {
                    name: "ABOUT_ASPN",
                    selected: false,
                    arrow: true,
                    path: "/info?id=about",
                },
                {
                    name: "DISCLAIMER",
                    selected: false,
                    arrow: true,
                    path: "/info?id=disclaimer",
                },
                {
                    name: "PRIVACY_POLICY",
                    selected: false,
                    arrow: true,
                    path: "/info?id=policy",
                },
            ],
            fantasySportLogoutUrl: config.fantasySportLogoutUrl,
            countryList: [],
            suggesstionCountryCode: "SG",
            countrySelected: "",
            langSelected: "",
            apiCallDone: true,
            countryListNotLogin: [
                {
                    countryCode: "SG",
                    country: "Singapore",
                    name: "Singapore",
                    id: "Singapore",
                    icon: "singapore",
                    callingCode: 65,
                    timeZone: "Asia/Singapore",
                    selected: false,
                    supportedLocale: ["en", "zh-Hans"],
                    countryLang: [
                        {
                            country: "England",
                            displayName: "English",
                            displayShorterName: "EN",
                            locale: "en",
                            displayLocale: "en",
                            selected: true,
                            active: true,
                            icon: "england",
                            apiParam: "en_MY",
                            selected2: false,
                        },
                        {
                            country: "China",
                            displayName: "简体中文",
                            displayShorterName: "简体",
                            locale: "zh-Hans",
                            momentLocale: "zh-cn",
                            displayLocale: "zh-Hans",
                            selected: false,
                            active: true,
                            icon: "china",
                            apiParam: "zh-Hans_CN",
                            selected2: false,
                        },
                    ],
                },
            ],
        };
    },
    components: {
        Avatar,
        DownloadIconList,
        ToastrDesktop,
    },
    computed: {
        ...mapGetters([
            "userLangConfig",
            "currentCountryObj",
            "isLogin",
            "isMobile",
            "currentLanguageObj",
            "userInfo",
            "currentCountryList",
            "currentLocale",
            "currentLanguageList",
        ]),
        myCountryIcon() {
            let countryCode = this.currentCountryObj.countryCode;
            for (var index in this.currentCountryList) {
                let item = this.currentCountryList[index];
                if (item.countryCode === countryCode) {
                    return item.icon;
                }
            }
        },
        mySinceDate(playerDate) {
            if (!this.userInfo.registrationDate) {
                return "";
            }
            let options = {
                // weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",
            };

            const [day, month, year] =
                this.userInfo.registrationDate.split("-");

            let date = `${year}-${month}-${day}`;
            let theDate = new Date(date);
            return this.$tools.getDateByLocale(
                this.currentLanguageObj.apiParam.replace("_", "-"),
                options,
                theDate
            );
        },
    },
    watch: {
        isMobile(newVal) {
            if(!newVal) {
                setTimeout(() => {
                    this.$router.push({
                        name: "Home",
                    });
                }, 100);
            }
        }
    },
    created() {
        if (!this.isMobile) {
            setTimeout(() => {
                this.$router.push({
                    name: "Home",
                });
            }, 100);
        }

        let theme = localStorage.getItem("themeMode");
        if (theme === "light") {
            this.isLight = true;
        }
    },
    mounted() {
        if (this.isLogin) {
            this.initCountryAndLanguageList();
        } else {
            this.languageList();
        }
    },
    methods: {
        ...mapMutations([
            "REMOVE_USER_LANG_CONFIG",
            "USER_SWITCH_COUNTRY_LANG",
            "UPDATE_USER_LANG_CONFIG",
            "SET_THEME_MODE",
            "SET_THEME_MODE_INDEX",
        ]),
        ...mapActions([
            "postLogout",
            "logoutEvent",
            "commonVerifyLogin",
            "setUserData",
            "postUpdateProfilePreferredCountry",
            "toastrChangeEvent",
            "postUpdateProfilePreferredLanguage",
            "currentCountryLocaleChangeEvent",
            "toggleCountryAndLanguage",
        ]),
        languageList() {
            this.countryListNotLogin.forEach((x) => {
                x.countryLang.forEach((a) => {
                    a.selected2 =
                        a.locale === this.$route.params.locale ? true : false;
                });
            });
        },
        initCountryAndLanguageList() {
            if (!this.isLogin) {
                return;
            }
            const countryList = this.currentCountryList;
            countryList.forEach((x) => {
                x.selected =
                    x.countryCode === this.userInfo.preferredCountry
                        ? true
                        : false;
            });

            const langList = this.currentLanguageList;
            let currentCountryCode = this.currentCountryObj.countryCode;
            let currentLocale = this.currentLocale;

            for (var i1 in countryList) {
                let countryCode = countryList[i1].countryCode;
                let supportedList = countryList[i1].supportedLocale;

                let countryLang = [];
                for (var i2 in langList) {
                    let langItem = JSON.parse(JSON.stringify(langList[i2]));
                    let locale = langItem.locale;
                    if (
                        countryCode === currentCountryCode &&
                        locale === currentLocale
                    ) {
                        langItem.selected2 = true;
                        this.countrySelected = countryList[i1];
                        this.langSelected = langItem;
                    } else {
                        langItem.selected2 = false;
                    }
                    if (supportedList.includes(locale)) {
                        countryLang.push(langItem);
                    }
                }
                countryList[i1]["countryLang"] = countryLang;
            }
            // this.countryList = countryList
            this.countryList = countryList;
        },
        async handleShare() {
            //www.asiasports.com/en/signup?code=2D1K3O
            https: if (this.$tools.mobileCheck()) {
                let title = `${this.$i18n.t(
                    "INVITE_YOUR_FRIEND"
                )}. ${this.$i18n.t("INVITE_CONTENT")}`;
                const shareData = {
                    title: "Get latest sports scoring, statistics, historical data and news update on ASPN.com",
                    text: title,
                    url: window.location.href,
                };
                try {
                    await navigator.share(shareData);
                } catch (err) {}
            } else {
                this.$refs.toastrDesktop.handleOpen();
            }
        },
        handleListItem(item) {
            if (item.pathName) {
                this.$router.push({
                    name: item.pathName,
                });
            } else if (item.path) {
                this.$router.push(`/${this.currentLocale}${item.path}`);
            } else if (item.type === "language") {
                this.initCountryAndLanguageList();
                this.isShowLanguageList = true;
            }
        },
        //handle logout
        async handleLogout() {
            let params = {
                token: this.userInfo.token,
            };

            const result = await this.postLogout(params);
            this.logoutEvent();

            //logout fantasy
            let fantasyHtml = $(
                `<iframe class="fantasy-iframe-logout" onload="$('.fantasy-iframe-logout').remove()" src="${this.fantasySportLogoutUrl}?logout=true"></iframe>`
            );
            $("body").append(fantasyHtml);

            this.REMOVE_USER_LANG_CONFIG();
            if (this.$route.meta.parent === "account") {
                this.$router.push(`/${this.currentLocale}`);
            }
            // if (result.result.businessCode === 0) {

            // } else {
            //     this.$root.toastrMsg = result.result.message;
            //     this.$root.toastrType = 'info';
            //     this.$root.toastrPosition = "top";
            //     this.$root.$refs.toastrRef.handleOpen();
            // }
        },
        handleClickTabs(name) {
            this.$router.push({
                name: name,
            });
        },
        selectLang(countryList, item, sec) {
            for (var i1 in countryList) {
                for (var i2 in countryList[i1].countryLang) {
                    countryList[i1].countryLang[i2].selected2 = false;
                }
            }

            sec.selected2 = true;
            this.countrySelected = item;
            this.langSelected = sec;
        },
        selectLangNotLogin() {
            for (var i1 in countryList) {
                for (var i2 in countryList[i1].countryLang) {
                    countryList[i1].countryLang[i2].selected2 = false;
                }
            }

            sec.selected2 = true;
            this.countrySelected = item;
            this.langSelected = sec;
        },
        handleDone() {
            if (this.isLogin) {
                this.countrySelectItem();
            } else {
                this.countrySelectItemNotLogin();
            }
        },
        async countrySelectItem() {
            if (this.isLogin && this.apiCallDone) {
                this.apiCallDone = false;

                let params = {
                    // preferredCountry: o.countryCode,
                    preferredCountry: this.countrySelected.countryCode,
                };

                const result = await this.postUpdateProfilePreferredCountry(
                    params
                );
                this.apiCallDone = true;

                if (result.result.businessCode === 0) {
                    // this.getRetrieveUserInfoData();
                    let localStorageUser = JSON.parse(
                        localStorage.getItem("user")
                    );
                    localStorageUser.preferredCountry =
                        this.countrySelected.countryCode;
                    this.setUserData(localStorageUser);
                    this.languageSelectItem(
                        this.langSelected,
                        this.countrySelected.countryCode,
                        this.countrySelected
                    );
                } else {
                    let params = {
                        isOpen: true,
                        msg: result.result.message,
                        type: "info",
                    };
                    this.toastrChangeEvent(params);
                }
            }
        },
        countrySelectItemNotLogin() {
            let params = JSON.parse(JSON.stringify(this.$route.params));
            let query = JSON.parse(JSON.stringify(this.$route.query));
            params.locale = this.langSelected.locale;

            localStorage.setItem("newsLang", JSON.stringify(this.langSelected));
            localStorage.setItem("language", this.langSelected.locale);
            this.isShowLanguageList = false;
            this.$router.push({
                name: this.$route.name,
                params: params,
                query: query,
            });
            // this.languageSelectItem(this.langSelected, this.countrySelected.countryCode, this.countrySelected);
            // setTimeout(() => {
            //     location.reload()
            // }, 500)
        },
        async languageSelectItem(o, countryCode = null, countrySelected) {
            if (this.apiCallDone) {
                this.apiCallDone = false;
                let theCountryCode =
                    countryCode === null
                        ? this.userInfo.preferredCountry
                        : countryCode;

                localStorage.setItem("newsLang", JSON.stringify(o));
                localStorage.setItem("language", o.locale);

                let params = {
                    preferredLanguage: o.locale,
                    token: this.userInfo.token,
                };
                const result = await this.postUpdateProfilePreferredLanguage(
                    params
                );
                this.apiCallDone = true;

                if (result.result.businessCode === 0) {
                    // this.getRetrieveUserInfoData();
                    let localStorageUser = JSON.parse(
                        localStorage.getItem("user")
                    );
                    localStorageUser.preferredLanguage = o.locale;
                    this.setUserData(localStorageUser);
                    this.currentCountryLocaleChangeEvent({
                        countryCode: theCountryCode,
                        locale: o.locale,
                    });

                    this.USER_SWITCH_COUNTRY_LANG();
                    //this.currentLocaleChangeEvent(o.displayLocale);//currentLanguageObj
                } else {
                    let params = {
                        isOpen: true,
                        msg: result.result.message,
                        type: "info",
                    };
                    this.toastrChangeEvent(params);
                    // this.$root.toastrMsg = result.result.message;
                    // this.$root.$refs.toastrRef.handleOpen();
                }

                this.toggleCountryAndLanguage();
                this.UPDATE_USER_LANG_CONFIG(o.displayLocale);
                this.isShowLanguageList = false;
            }
        },
        changeMode(e) {
            localStorage.setItem("themeMode", this.isLight ? "light" : "dark");
            this.initTheme();
        },
        initTheme() {
            let theme = localStorage.getItem("themeMode");
            this.SET_THEME_MODE(theme);
            if (theme === "dark") {
                document.body.style.background = "var(--gray-900)";
            } else {
                document.body.style.background = "var(--gray-100)";
            }
            if (!this.isMobile) {
                if (theme === "light") {
                    this.SET_THEME_MODE_INDEX("lightWeb");
                } else {
                    this.SET_THEME_MODE_INDEX("darkWeb");
                }
            } else {
                if (theme === "light") {
                    this.SET_THEME_MODE_INDEX("lightWebapp");
                } else {
                    this.SET_THEME_MODE_INDEX("darkWebapp");
                }
            }
        },
        async handleShare() {
            if (this.$tools.mobileCheck()) {
                let title = "ASPN";
                const shareData = {
                    title: "Get latest sports scoring, statistics, historical data and news update on ASPN.com",
                    text: title,
                    url: window.location.href,
                };
                try {
                    await navigator.share(shareData);
                } catch (err) {}
            } else {
                this.$refs.toastrDesktop.handleOpen();
            }
        },
    },
};
</script>

<style scoped>
.more-container {
    background-color: var(--color-background-default-secondary);
    padding: 18px 24px 16px;
    border-radius: 0 0 16px 16px;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.02),
        0px 2px 2px 0px rgba(0, 0, 0, 0.02), 0px 4px 4px 0px rgba(0, 0, 0, 0.02),
        0px 8px 8px 0px rgba(0, 0, 0, 0.02);
}
.join-container {
    display: flex;
    align-items: center;
}
.join-avatar-img {
    flex-shrink: 0;
    width: 51.52px;
    height: 51.52px;
    margin-right: 18.24px;
}
.join-team-data {
}
.join-team-title {
    color: var(--color-text-default-default);
    font-size: 16px;
    font-family: var(--weight-700);
    letter-spacing: 0.64px;
}
.join-team-title.name {
    font-size: 24px;
    letter-spacing: -0.64px;
    font-family: var(--weight-600);
    display: flex;
    align-items: center;
}
.edit-pen {
    margin-left: 8px;
}

.join-team-content {
    font-size: 12px;
    letter-spacing: 0.2px;
    color: var(--color-text-default-default);
}
.join-team-content.member-since {
    color: var(--color-text-default-secondary);
}
.tab {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
.tab-item {
    flex: 1;
    padding: 8px 0;
    text-align: center;
    border-radius: 19px;
    color: var(--color-text-default-default);
    border: 1px solid var(--color-border-default-default);
    cursor: pointer;
    font-family: var(--weight-600);
}
.tab-item:first-child:hover {
    background-color: var(--primary-500);
    color: var(--color-button-active);
}
.tab-item:last-child {
    background-color: var(--primary-500);
    color: var(--color-button-active);
}
.list-container {
}
.list-title {
    color: var(--color-text-default-default);
    font-size: 20px;
    font-family: var(--weight-700);
    margin: 16px 0;
    padding: 0 24px;
}
.list-title-settings {
    margin-top: 32px;
}
.list {
    padding: 0 8px;
}
.list-item {
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
    margin-bottom: 8px;
    font-size: 16px;
    font-family: var(--weight-600);
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    color: var(--color-text-default-default);
    letter-spacing: 0.64px;
}
.list-item:hover {
    background-color: var(--color-background-default-default-hover);
}
.language-text {
    color: var(--color-text-default-secondary);
    font-size: 13px;
    font-family: var(--weight-400);
    display: flex;
    align-items: center;
}
.country-icon-box {
    width: 18px;
    height: 18px;
    margin-right: 4px;
    border: 1px solid var(--color-border-default-default);
    border-radius: 50%;
}
.country-icon {
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 50%;
}
.version-text {
    text-align: center;
    color: var(--color-text-default-default);
    font-weight: var(--weight-600);
    font-family: var(--weight-600);
    margin-bottom: 16px;
}
.copyright {
    text-align: center;
    color: var(--color-text-default-default);
}
.more-footer-container {
    padding: 16px 0 76px;
}

.invite-card {
    background: var(--color-background-invite-card);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 31.42px 21.6px;
    gap: 16px;
    border-radius: 16px;
    margin: 20px 0 0;
}
.invite-data {
}
.invite-title {
    font-size: 16px;
    font-family: var(--weight-600);
    color: var(--color-text-default-neutral);
    letter-spacing: 0.64px;
}
.invite-content {
    letter-spacing: 0.2px;
    color: var(--color-text-default-tertiary);
    font-size: 13px;
}
.invite-button {
    border-radius: 16px;
    background-color: var(--color-background-default-secondary);
    color: var(--color-text-default-default);
    border: 1px solid var(--color-border-default-default);
    display: flex;
    align-items: center;
    padding: 8px 16px;
    font-size: 13px;
    flex-shrink: 0;
    font-family: var(--weight-700);
}
.share-icon {
    margin-left: 8px;
}
.sign-out {
    padding: 22px 0;
    text-align: center;
}
.sign-out-text {
    color: var(--color-text-primary-default);
    font-family: var(--weight-700);
    text-transform: uppercase;
    cursor: pointer;
}
.country-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--color-border-default-default);
    padding: 21px 16px;
    font-family: var(--weight-700);
    color: var(--color-text-default-default);
}
.done-text {
    color: var(--color-text-primary-default);
}
.language-list {
}
.language-item {
    padding: 9px 55px;
    color: var(--color-text-default-default);
}
.language-item.selected {
    background-color: var(--color-background-default-secondary-hover);
}
.country-item {
    padding: 8px 16px;
    color: var(--color-text-default-secondary);
    font-weight: normal;
    display: flex;
    align-items: center;
    gap: 8px;
}
.country-lang-item {
    /* padding: 0 16px; */
    font-family: var(--weight-700);
    margin-bottom: 8px;
}
</style>

<style scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 76px;
    height: 40px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--color-background-neutral-default);
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 32px;
    width: 32px;
    left: 4px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}
.switch.is-light .slider:before {
    bottom: 4px;
    left: 3px;
}

.switch input:checked + .slider {
    background-color: #2196f3;
}

.switch input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
}

.switch input:checked + .slider:before {
    -webkit-transform: translateX(35px);
    -ms-transform: translateX(35px);
    transform: translateX(35px);
}

.switch input:focus ~ span,
.switch input:not(:focus):valid ~ span {
    top: 0;
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.switch.is-light input:focus + .slider {
    box-shadow: 0 0 1px var(--color-background-neutral-default);
}
.switch.is-light input:checked + .slider {
    background-color: var(--color-background-neutral-default);
}
.switch-sun {
    position: relative;
    z-index: 5;
    top: 7.5px;
    left: 7.5px;
}
.switch-moon {
    position: relative;
    z-index: 5;
    top: 7.5px;
    left: 44.5px;
}
.switch.is-dark .slider {
    background-color: var(--gray-50);
    border: 1px solid var(--gray-600);
}

.switch.is-dark .slider:before {
    background-color: var(--gray-800);
}
.more-content {
    background-color: var(--color-background-default-default);
}
</style>

<style>
@media(max-width: 768px) {
    /* for test */

    .popup-country {
        height: 90vh;
        width: 100%;
        border-radius: 8px 8px 0 0;
        max-height: 90vh;
        overflow-y: hidden;
    }
    .popup-country.unlogin {
        width: 100% !important;
        height: auto !important;
    }
    .language-title {
        font-size: 16px;
        font-family: var(--weight-600);
        line-height: 140%;
        color: var(--color-text-default-default);
        padding: 16px;
    }
    .language-title.others {
        border-top: 1px solid var(--color-border-default-default);
        padding-top: 24px;
        margin-top: 8px;
    }
}
</style>
